var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export var CartAlt = function CartAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.915 3.703A.872.872 0 005.06 3H2.871A.872.872 0 002 3.874c0 .483.39.873.871.873h1.684l.575 3.19.012.08.156.852.512 2.827h.01l.54 2.919a1.76 1.76 0 001.737 1.429h10.926c.853 0 1.585-.601 1.737-1.43l1.218-6.597c.148-.801-.476-1.539-1.302-1.539H6.423l-.508-2.775zM8.087 18a1.522 1.522 0 110 3.045 1.522 1.522 0 010-3.045zm10.435 0a1.522 1.522 0 110 3.045 1.522 1.522 0 010-3.045z",
    fill: "currentColor",
    fillOpacity: 0.96
  })));
};